import { render, staticRenderFns } from "./BookmarkBrandButton.vue?vue&type=template&id=58334c66&scoped=true&"
import script from "./BookmarkBrandButton.vue?vue&type=script&lang=ts&"
export * from "./BookmarkBrandButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58334c66",
  null
  
)

export default component.exports